var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Alert, Snackbar } from "@mui/material";
import React from "react";
var GlobalSnackbar = function (_a) {
    var snackbar = _a.snackbar, setSnackbar = _a.setSnackbar;
    return (_jsx(Snackbar, __assign({ open: snackbar.open, autoHideDuration: 6000, onClose: function () { return setSnackbar(__assign(__assign({}, snackbar), { open: false })); }, anchorOrigin: { vertical: "bottom", horizontal: "center" } }, { children: _jsx(Alert, __assign({ severity: snackbar.severity || "info", onClose: function () { return setSnackbar(__assign(__assign({}, snackbar), { open: false })); }, sx: {
                width: "100%",
                display: "flex",
                alignItems: "center",
            } }, { children: snackbar.message })) })));
};
export default GlobalSnackbar;
